import { themeGet } from '@styled-system/theme-get'
import { AnimatePresence, m } from 'motion/react'
import { FC } from 'react'
import styled from 'styled-components'

import { Spinner as BaseSpinner } from '@hap/components'

import useLoader from './useLoader'

const Spinner = styled(BaseSpinner)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const LoadingContainer = styled(m.div)`
  position: fixed;
  bottom: 1.5em;
  right: 1.5em;
  display: flex;
  align-items: center;
  gap: 15px;
  border-radius: 40px;
  width: 46px;
  height: 46px;
  background-color: ${themeGet('colors.accent3')};
  z-index: ${themeGet('zIndices.toast')};
`

const LoadingIndicator: FC = () => {
  const { isLoading } = useLoader()
  return (
    <AnimatePresence>
      {isLoading ? (
        <LoadingContainer initial={{ y: 100 }} animate={{ y: 0 }} exit={{ y: 100 }}>
          <Spinner size={30} />
        </LoadingContainer>
      ) : null}
    </AnimatePresence>
  )
}

export default LoadingIndicator
